import PropTypes from 'prop-types';

const ChangePasswordPropTypes = {
  username: PropTypes.string,
};

export default ChangePasswordPropTypes;
